<template>
  <div class="view">


    <div class="project-header" :style="header_cls">
      <div class="pretitle">
        Kunde
      </div>
      <div class="title">{{client.name}}</div>
    </div>

    
    <div class="filterbtns">
      <filterbtn :active="showing=='projects_active'" @click.native="setShowing('projects_active')">Aktive opgaver</filterbtn>
      <filterbtn :active="showing=='projects'" @click.native="setShowing('projects')">Alle opgaver</filterbtn>
      <filterbtn :active="showing=='details'" @click.native="setShowing('details')">Detaljer</filterbtn>
      <filterbtn :active="showing=='economy'" v-if="economy_access" @click.native="setShowing('economy')">Økonomi</filterbtn>
      <filterbtn :active="showing=='comments'" @click.native="setShowing('comments')">{{getCommentsCount('client',client['.key'])}} kommentarer</filterbtn>
      <filterbtn :active="showing=='settings'" @click.native="setShowing('settings')">Indstillinger</filterbtn>
    </div>


    <box v-if="client && showing == 'settings' ">

      <inputfield label="Navn">
        <input type="text" :value="client.name" @change="change('name',$event)">
      </inputfield>

      <br>

      <inputfield label="Farve">
        <input type="text" :value="client.color" @change="change('color',$event)">
      </inputfield>

      <br>
      
      <inputfield label="Timepris (Kan også projektdefineres)">
        <input type="number" :value="client.hour_rate" @change="change('hour_rate',$event)">
      </inputfield>

      <br>

      <inputfield label="Tags">
        <input type="text" v-model="client.tags" @change="change('tags',$event)" />
      </inputfield>

      <br>

      <inputfield label="Background image tags (commasep eg: nature,water)">
        <input type="text" v-model="client.bgimg_tags" @change="change('bgimg_tags',$event)" />
      </inputfield>

      <br>
      
      <inputfield label="CVR nummer">
        <input type="text" v-model="client.cvr" @change="change('cvr',$event)" />
      </inputfield>

      <br>

      <btn color="2" @click.native="submitChanges()">Gem</btn>

      <br><br>

      <btn @click.native="archiveClient()">Arkivér kunde</btn>

    </box>

    
    <box v-if="economy_access && showing == 'economy' " label="Økonomiposter">      

      <economy-posts :posts="economyposts.posts" :totals="economyposts.totals" fields="title,client,project,invoice_no,invoice_date,invoiced,paid,amount" />    

    </box>

    <box v-if="economy_access && showing == 'economy' " label="Dinero faktura-oversigt">      
      <div class="btn" @click="dinero_fetch_invoices()" v-if="!$store.state.dinero_fetched">Indlæs Dinero fakturaer</div>
      <dinero-invoices v-if="$store.state.dinero_fetched && client_dinero_invoices" :invoices="client_dinero_invoices" />
    </box>

    

  	<box label="Detaljer" v-if=" showing == 'details' ">
      
      
      <table class="table-a">     
          <tr>
            <td>Kundens timepris</td>
            <td>{{ client.hour_rate | money(2) }} kr.</td>
          </tr>
          
          <tr v-if="economy_access">
            <td>Indtjening i alt</td>
            <td>{{ client_total_earning | money(2) }} kr.</td>
          </tr>

          <tr v-if="economy_access">
            <td>Faktureret i alt (Dinero)</td>
            <td>{{ client_dinero_invoiced_total | money(2) }} kr.</td>
          </tr>

          <tr>
            <td>timer tracket i alt</td>
            <td>{{ client_timelog_totals | decimals(2) }} timer</td>
          </tr>

          <tr v-if="economy_access">
            <td>Reel timepris</td>
            <td>
              {{ client_total_earning / client_timelog_totals | money(2) }} kr.
            </td>
          </tr>

          <tr>
            <td>Kunde oprettet</td>
            <td>{{ client.created | date('DD/MM-YYYY HH:MM') }} </td>
          </tr>

      </table>

    </box>


  	<box :label="clientActiveProjects.length+' opgaver'" v-if=" showing == 'projects_active' ">

      <table class="table-a projects-table">        
          <tr>
            <th></th>
            <th>Opgave</th>
            <th>Budget</th>
            <th>Estimeret</th>
            <th>Tracket</th>
            <th>Tidsforbrug</th>
            <th></th>
          </tr>        
        
          <tr v-for="(project,i) in clientActiveProjects" :key="'fadsfd'+i">
            <td><avatar :input="project"></avatar></td>
            <td>
              <router-link class="textlink" :to="'/project/'+project['.key']">{{project.name}}</router-link>
            </td>
            <td>{{project.budget | money(0) | fallback2(0)}} kr.</td>
            <td>{{project.estimated_hrs | fallback2(0)}} T</td>
            <td>{{project.timelogs_total_hours | decimals(2) | fallback2(0)}} T</td>
            <td>{{ project.budgetted_hours_spent_pct }} %</td>
            <td>
              <div class="timelog-play-btn" @click="openTimeloggerBasic({project_key:project['.key']})"><svgicon icon="ionicons/ios-play"></svgicon></div>
            </td>
          </tr>
        
      </table>

      <br>

      <btn class="hide" @click.native="createNewClientProject({status:'active'})">Opret ny opgave</btn>

    </box>

    <box :label="clientProjects.length+' opgaver'" v-if=" showing == 'projects' ">

      <table class="table-a projects-table">        
          <tr>
            <th></th>
            <th>Opgave</th>
            <th>Status</th>
            <th>Budget</th>
            <th v-if="false">Estimeret</th>
            <th>Tracket</th>
            <th>Tidsforbrug</th>
            <th></th>
          </tr>        
        
          <tr v-for="(project,i) in clientProjects" :key="'fadsfd'+i">
            <td><avatar :input="project"></avatar></td>
            <td>
              <router-link class="textlink" :to="'/project/'+project['.key']">{{project.name}}</router-link>
            </td>
            <td>{{project.status_translated}}</td>
            <td>{{project.budget | money(0) | fallback2(0)}} kr.</td>
            <td v-if="false">{{project.estimated_hrs | fallback2(0) }} T</td>
            <td>{{project.timelogs_total_hours | decimals(2) | fallback2(0)}} T</td>
            <td>{{ project.budgetted_hours_spent_pct }} %</td>
            <td>
              <div class="timelog-play-btn" v-if="project.status != 'finished'" @click="openTimeloggerBasic({project_key:project['.key']})"><svgicon icon="ionicons/ios-play"></svgicon></div>
            </td>
          </tr>
        
      </table>

      <br>

      <btn class="hide" @click.native="createNewClientProject()">Opret ny opgave</btn>

    </box>


    <box v-if="showing=='comments'" :label="'Kommentarer'">
      <comments :keytype="'client'" :keyis="client['.key']" />
    </box>  

    <box v-if="show_debug_data_boxes" label="client">
      <pre>{{client}}</pre>
    </box>  

  </div>
</template>

<script>
import moment from 'moment';
import helpers from '../helpers.js';
import mixins from '../mixins.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Filterbtn from '.././components/Filterbtn'
import Comments from '.././components/Comments'
import EconomyPosts from '.././components/EconomyPosts'
import DineroInvoices from '.././components/DineroInvoices'
import Avatar from '.././components/Avatar'
import fdb from '.././firebase_config.js';
export default {
  name: 'client',
  mixins: [ mixins.db, mixins.generic ],
  components: { Box, Btn, Avatar, Inputfield, Filterbtn, Comments, EconomyPosts, DineroInvoices },
  data: function () {
    return {
      globals: this.$parent.globals,
      changes: {},
      client_id: this.$route.params.id,
      showing: 'projects_active',
    }
  },
  computed: {

    
    client_key(){ return this.$route.params.id },
    client(){ return this.getOne('client',this.client_key) },    

    // old - remove this and use the one above.
    clientProjects(){
      var output = []
      
      for( let project of this.getAll('projects'))  {
        
        if( project.client_key != this.client_id ) continue        
        if( project.archived ) continue

        project.status_translated = helpers.translateProjectStatus(project.status)

        project.timelogs = this.$store.getters['timelogs/get_cached'].project[project._key]
        project.timelogs_total_hours = this.$store.getters['timelogs/getTotalHours'](project.timelogs)
        project.budget = this.$store.getters['projects/getBudget'](project)        
        project.budgetted_hours_spent_pct = this.$store.getters['projects/get_budgetted_hours_spent_pct'](project,project.timelogs)
        
        output.push(project)
      }
      return output
    },

    clientActiveProjects(){ return this.clientProjects.filter( project => project.status == 'active' ) },
    clientFinishedProjects(){ return this.clientProjects.filter( project => project.status == 'finished' ) },

    economyposts(){
      var client_posts = this.$store.getters['economyposts/getFiltered']({
        client_key: this.client.key,
      })
      
      var project_keys = this.clientProjects.map(a => a.key)
      var project_posts = this.$store.getters['economyposts/getFiltered']({
        project_keys: project_keys,
      })
      
      var economyposts = client_posts.concat(project_posts)
      var totals = this.$store.getters['economyposts/getTotals'](economyposts)

      return { posts:economyposts, totals:totals  }
    },


    client_timelogs(){ return this.$store.getters['timelogs/get_cached'].client[this.client_key] },

    client_timelog_totals(){ return this.$store.getters['timelogs/getTotalHours']( this.client_timelogs) },
    client_total_earning(){ return this.$store.getters['clients/get_total_earning'](this.client.key) },

    clientColor(){
      if( this.client.color ) return this.client.color
      var initials = helpers.getItemInitials(this.client)
      return helpers.getColorByString(initials)
    },
    
    header_cls(){
      return {
        //'background-image': 'url(https://source.unsplash.com/random)',
        'background-color': this.clientColor,
        'color': 'white',
      }
    },

    client_dinero_invoices(){
      if( !this.client.cvr ) return []
      return this.$store.getters.get_dinero_invoices({ client_cvr:this.client.cvr })
    },

    client_dinero_invoiced_total(){
      if( !this.client.cvr ) return []
      return this.$store.getters.get_dinero_invoices_total({ client_cvr:this.client.cvr })
    },

  },
  methods: {

    getProjectBudgetTotal: helpers.getProjectBudgetTotal,
    getProjectHoursEstimate: helpers.getProjectHoursEstimate,
    outputMoney: helpers.outputMoney,
    getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,
    clientTotalEarning: helpers.clientTotalEarning,
    getClientProjects: helpers.getClientProjects,    

    setShowing(input){
      this.showing = input
    },

    openTimelogger(input){ eventBus.$emit('openTimelogger',input) },

    

    createNewClientProject(input){
      var p = {
        name: 'Ny opgave',
        client_key: this.$route.params.id,
        payment_model: 'fixed_price',
        created: moment().unix(),
      }

      if(input) {
        if(input.status) p.status = input.status
      }

      if( !p.hour_rate && this.client.hour_rate ) p.hour_rate = this.client.hour_rate

      if( this.client.color ) p.color = this.client.color
      
      fdb.ref('projects').push(p)
    },

    change( key, e ) {
      var val = e.target.value
      this.changes[key] = val
    },

    goto(url){
      this.$router.push(url)
    },

    submitChanges() {
      var id = this.$route.params.id
      var data = this.changes      
      fdb.ref('clients').child(id).update(data)      
      eventBus.$emit('toast', {text:'Saved'})
      this.$forceUpdate()
    },

    incrementGlobalCount() {
		  //console.log(this.$root)
		  //this.$parent.globals.count++
		  window.globals.count++
	  },

    archiveClient(){

      if( this.clientProjects.length ) {
        this.toast('Du kan ikke arkivere en kunde med tilknyttede projekter. Start med at flytte eller arkivere projekterne først.')
        return
      }

      var confirmed = confirm('Sikker?')
      if( !confirmed ) return
      var confirmed2 = confirm('Helt sikker?')
      if( !confirmed2 ) return
      
      var key = this.$route.params.id
      fdb.ref('clients').child(key).update({ archived:true })
      this.$router.replace('/clients')
    },

    dinero_fetch_invoices(){
      this.set_small_spinner(1)
      var _this = this
      this.$store.dispatch('dinero_fetch','latest')
        .then((response)=>{
          _this.toast('Dinero data indlæst!')
          _this.set_small_spinner(0)
        })
        .catch((error)=>{
          _this.toast('Fejl, kunne ikke indlæse fra Dinero...')
          _this.set_small_spinner(0)
        })
    },

    

  },//methods

  created(){

  },

  mounted(){
    this.$store.commit('set_context_bgcolor', this.clientColor)
    if( this.client.bgimg_tags ) this.$store.dispatch('load_context_bgimg', 'https://source.unsplash.com/1200x600/?'+this.client.bgimg_tags+'')
  },

  destroyed(){

        this.$store.commit('set_context_bgcolor', null)
        this.$store.commit('set_context_bgimg', null)

  },

}
</script>



// WEBPACK FOOTER //
// Client.vue?98dd9586